.container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
  min-width: 0;
}

.topBannerBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
  background: linear-gradient(135deg, rgba(134, 242, 228, 0.35), rgba(220, 233, 255, 0.55));
  border: 1px solid rgba(0, 106, 97, 0.28);
  border-radius: var(--radius-lg);
  padding: 0.95rem 1.2rem;
}

.topBannerText {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
}

.topBannerTitle {
  font-family: var(--font-display);
  font-size: 0.95rem;
  font-weight: 800;
  color: #0d1c2e;
}

.topBannerSub {
  font-size: 0.78rem;
  color: #444651;
}

.switchViewBtn {
  padding: 0.58rem 0.95rem;
  min-height: 42px;
  border-radius: var(--radius-sm);
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
}

.switchViewBtn:hover {
  background: #dce9ff;
}

.topGrid {
  display: grid;
  grid-template-columns: 1fr 1.15fr;
  gap: 1.25rem;
  min-width: 0;
}

.card {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-lg);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: var(--shadow-card);
  min-width: 0;
}

.title {
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 1.05rem;
  font-weight: 800;
  color: #0d1c2e;
}

.subtitle {
  font-size: 0.8rem;
  color: #444651;
}

.policyBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.rateHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.rateBig {
  font-family: var(--font-display);
  font-size: 1.85rem;
  font-weight: 800;
  color: #00236f;
  font-variant-numeric: tabular-nums;
}

.slider {
  width: 100%;
  accent-color: #00236f;
  cursor: pointer;
}

.modeToggleGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.55rem;
}

.modeBtn {
  padding: 0.65rem 0.8rem;
  min-height: 42px;
  border-radius: var(--radius-sm);
  border: 1px solid #d5e3fc;
  background: #ffffff;
  color: #444651;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s ease;
}

.modeBtnActive {
  border-color: #00236f;
  background: rgba(0, 35, 111, 0.08);
  color: #00236f;
  font-weight: 700;
}

.formStack {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.fieldRow {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

.fieldRowThree {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
}

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 0.32rem;
  min-width: 0;
}

.label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #444651;
}

.input,
.select {
  width: 100%;
  min-height: 42px;
  background: #ffffff;
  border: 1px solid #c5c5d3;
  color: #0d1c2e;
  border-radius: 10px;
  padding: 0.56rem 0.72rem;
  font-size: 0.84rem;
  outline: none;
  font-variant-numeric: tabular-nums;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input:focus,
.select:focus {
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
}

.frequencyPreviewBox {
  background: rgba(134, 242, 228, 0.3);
  border: 1px solid rgba(0, 106, 97, 0.35);
  color: #005049;
  border-radius: var(--radius-sm);
  padding: 0.68rem 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-variant-numeric: tabular-nums;
}

.frequencyCalcRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.checkboxRow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.76rem;
  color: #444651;
  cursor: pointer;
}

.primaryBtn {
  padding: 0.68rem 1rem;
  min-height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  border: 1px solid #00236f;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.18);
  font-weight: 700;
  font-size: 0.84rem;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.primaryBtn:hover {
  box-shadow: 0 6px 16px rgba(0, 35, 111, 0.25);
}

.secondaryBtn {
  padding: 0.45rem 0.75rem;
  min-height: 36px;
  border-radius: var(--radius-sm);
  background: #eff4ff;
  border: 1px solid #d5e3fc;
  color: #00236f;
  font-weight: 700;
  font-size: 0.75rem;
  cursor: pointer;
}

.dangerBtn {
  padding: 0.45rem 0.75rem;
  min-height: 36px;
  border-radius: var(--radius-sm);
  background: #ffdad6;
  border: 1px solid rgba(186, 26, 26, 0.28);
  color: #93000a;
  font-weight: 700;
  font-size: 0.75rem;
  cursor: pointer;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.listItem {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.85rem 0.95rem;
  border-radius: var(--radius-md);
  background: #eff4ff;
  border: 1px solid #dce9ff;
  font-variant-numeric: tabular-nums;
}

.listItemMain {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.itemActionsRow {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
  margin-top: 0.25rem;
}

.inlineEditBox {
  border-top: 1px dashed #c5c5d3;
  padding-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.emptyStateBox {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: var(--radius-md);
  padding: 1.15rem;
  text-align: center;
  font-size: 0.8rem;
  color: #444651;
}

.itemTitle {
  font-family: var(--font-display);
  font-size: 0.9rem;
  font-weight: 700;
  color: #0d1c2e;
}

.itemMeta {
  font-size: 0.75rem;
  color: #444651;
  line-height: 1.38;
}

.itemAmount {
  font-family: var(--font-display);
  font-variant-numeric: tabular-nums;
  font-size: 1.02rem;
  font-weight: 800;
  color: #006a61;
}

.windfallSection {
  display: grid;
  grid-template-columns: 430px minmax(0, 1fr);
  gap: 1.25rem;
  min-width: 0;
}

.policyTag {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.16rem 0.52rem;
  border-radius: 6px;
  background: #dce9ff;
  color: #00236f;
}

@media (max-width: 980px) {
  .topGrid,
  .windfallSection {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 640px) {
  .fieldRow,
  .fieldRowThree,
  .modeToggleGroup {
    grid-template-columns: minmax(0, 1fr);
  }

  .card {
    padding: 0.95rem;
  }

  .switchViewBtn {
    width: 100%;
    text-align: center;
  }
}
